function process_Rep_data(transaction_data) {
  const monthMapping = {
    1: "Jan", 2: "Feb", 3: "Mar", 4: "Apr", 5: "May", 6: "Jun",
    7: "Jul", 8: "Aug", 9: "Sep", 10: "Oct", 11: "Nov", 12: "Dec",
  };

  const list_of_objects = [];
  let total_sales = 0;
  let count = 0;

  for (let i = 0; i < transaction_data.length; i++) {
    const rep_details = transaction_data[i]["repDetails"];
    const rep_name = rep_details["repname"];
    const total_array = rep_details["total"] || [];
    
    let rep_total_sales = 0;
    const monthTotals = {};
    
    for (let k = 0; k < total_array.length; k++) {
      const { year, month, total } = total_array[k];
      rep_total_sales += total;
      
      const monthStr = monthMapping[Number(month)];
      const yearStr = String(year).slice(-2);
      const monthYearKey = `${monthStr}-${yearStr}`;
      
      if (!monthTotals[monthYearKey]) {
        monthTotals[monthYearKey] = { sales: 0 };
      }
      monthTotals[monthYearKey].sales += total;
    }
    
    total_sales += rep_total_sales;
    
    list_of_objects.push({
      "_id": ++count,
      "repname": rep_name,
      "sales": Math.round(rep_total_sales),
      ...Object.fromEntries(
        Object.entries(monthTotals).map(([key, val]) => [key, { sales: Math.round(val.sales) }])
      )
    });
  }

  for (let i = 0; i < list_of_objects.length; i++) {
    const percentage_contribution = total_sales > 0 ? (list_of_objects[i].sales / total_sales) * 100 : 0;
    list_of_objects[i].percentage_contribution = percentage_contribution.toFixed(2);
  }
  
  return list_of_objects;
}




// const axios = require('axios');
// const url = '${process.env.REACT_APP_SERVER_BASE_URL}/transactionreports/rep/search?name=all&startyear=2023&actual=false&startingmonth=false';
// async function fetchTransactionData() {
//     try {
//       const response = await axios.get(url);
//       const transaction_data = response.data;
//     //   console.log(transaction_data);
//       return transaction_data; // Return rep_data
//     } catch (error) {
//       console.error('Error:', error);
//       return null; // Return null or handle the error accordingly
//     }
//   }

//   fetchTransactionData().then(transaction_data => {
//     processed_data = process_Rep_data(transaction_data)
//     console.table(processed_data)
//   })


export default process_Rep_data;
  